function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "adjustments-horizontal",
  transform: "translate(-5 -5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11579",
  "data-name": "Path 11579",
  d: "M24,9a3,3,0,1,1-3-3A3,3,0,0,1,24,9Z",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11580",
  "data-name": "Path 11580",
  d: "M6,9H18",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11581",
  "data-name": "Path 11581",
  d: "M24,9h6",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11582",
  "data-name": "Path 11582",
  d: "M15,18a3,3,0,1,1-3-3A3,3,0,0,1,15,18Z",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11583",
  "data-name": "Path 11583",
  d: "M6,18H9",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11584",
  "data-name": "Path 11584",
  d: "M15,18H30",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11585",
  "data-name": "Path 11585",
  d: "M28.5,27a3,3,0,1,1-3-3A3,3,0,0,1,28.5,27Z",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11586",
  "data-name": "Path 11586",
  d: "M6,27H22.5",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11587",
  "data-name": "Path 11587",
  d: "M28.5,27H30",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgAdjustmentsHorizontal = function SvgAdjustmentsHorizontal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdjustmentsHorizontal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adjustments-horizontal.f245441a.svg";
export { ForwardRef as ReactComponent };